/**
 * React Query key factory for the Fias Forge arche (ADR-023).
 *
 * Owned by the arche so the central `client/src/lib/query-keys.ts` does not
 * host per-arche namespaces; the central file re-exports this under
 * `queryKeys.forge` (the social-media pattern). Keys are hierarchical: a
 * mutation on one forge invalidates `detail(forgeId)`, which also drops its
 * turns and test-builds views.
 */
export const forgeQueryKeys = {
  all: ['forge'] as const,
  lists: () => [...forgeQueryKeys.all, 'list'] as const,
  list: (params: { includeArchived: boolean; includeShared?: boolean }) =>
    [...forgeQueryKeys.lists(), params] as const,
  details: () => [...forgeQueryKeys.all, 'detail'] as const,
  detail: (forgeId: string) => [...forgeQueryKeys.details(), forgeId] as const,
  turns: (forgeId: string) => [...forgeQueryKeys.detail(forgeId), 'turns'] as const,
  testBuilds: (forgeId: string) => [...forgeQueryKeys.detail(forgeId), 'test-builds'] as const,
  /** The forge's publishing options. */
  publishSettings: (forgeId: string) =>
    [...forgeQueryKeys.detail(forgeId), 'publish-settings'] as const,
  /** What the forge has cost so far — polled while a turn runs. */
  cost: (forgeId: string) => [...forgeQueryKeys.detail(forgeId), 'cost'] as const,
  /** The test build a `?channel=test` host renders — keyed by ARCHE id. */
  testChannel: (archeId: string) => [...forgeQueryKeys.all, 'test-channel', archeId] as const,
  /** The caller's meter readings (hours, storage, holds) — one per user. */
  usage: () => [...forgeQueryKeys.all, 'usage'] as const,
};
